<!-- 充值中心 -->
<template>
  <div class="recharge">
    <div class="wrap">
      <p class="title">银行卡充值</p>
      <div class="item align">
        <span class="item_title">充值方式：</span>
        <span class="item_content">银行卡充值</span>
      </div>
      <div class="item align">
        <span class="item_title">充值游戏：</span>
        <select id="select" name="select">
          <option selected="selected">游戏代币</option>
        </select>
      </div>
      <div class="item align">
        <span class="item_title">充值服务器：</span>
        <select id="select" name="select2">
					<option>北京</option>
				</select>
      </div>
      <div class="item align">
        <span class="item_title">充值账号：</span>
        <input type="text" class="card_input"/>
      </div>
      <div class="item align">
        <span class="item_title">充值比例：</span>
        <span>1元人民币= 1000农场币</span>
      </div>
      <div class="item align">
        <span class="item_title">充值金额：</span>
        <select id="select" name="select2">
          <option>10元</option>
          <option>100元</option>
          <option>1000元</option>
        </select>
      </div>
      <div class="item">
        <span class="item_title">选择银行：</span>
        <ul>
          <li>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank1.gif">
            </label>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank2.gif">
            </label>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank3.gif">
            </label>
          </li>
          <li>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank4.gif">
            </label>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank5.gif">
            </label>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank6.gif">
            </label>
          </li>
          <li>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank7.gif">
            </label>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank8.gif">
            </label>
            <label class="box">
              <input class="input radio" type="radio" name="demo-radio">
              <span class="span"></span><img class="bank" alt="" src="https://cdn.welove520.com/static/res/vue/playbay/bank9.gif">
            </label>
          </li>
        </ul>
      </div>
      <img class="btn_pay" src="https://cdn.welove520.com/static/res/vue/playbay/recharge_pay.png" @click="recharge">
      <div class="flowpath">
        <p>银行卡支付操作流程</p>
        <p>· 在充值中心填写要充入的帐号和充值额度，确认要充值的信息，选择使用的银行，点击立即充值。</p>
        <p>· 进入银行卡支付页面，填写银行卡号及密码等，确认金额支付。</p>
        <p>· 确认后返回充值页面---充值成功。游戏内查收</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Recharge",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "recharge");
  },
  methods: {
    recharge: function() {
      this.$router.push({
        name: "Login"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  margin: 20px 20px 0 0;
}

.input {
  display: none;
}

.span {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 100%;
  display: inline-block;
  height: 16px;
  margin-right: 5px;
  margin-top: -1px;
  vertical-align: middle;
  width: 16px;
  line-height: 1;
}

.input:checked + .span:after {
  background-color: #00a1e9;
  border-radius: 100%;
  content: "";
  display: inline-block;
  height: 8px;
  margin-top: -5px;
  width: 8px;
  margin-left: 2px;
  vertical-align: middle;
}

.input:checked + .span {
  border: 2px solid #00a1e9;
}

ul,
li {
  list-style: none;
}

input {
  outline: none;
}

select {
  border: 1px solid #88898e;
  border-radius: 5px;
  padding: 3px 8px;
}

.recharge {
  width: 900px;
  margin: 50px auto 70px auto;
}

.wrap {
  width: 100%;
  height: 870px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #f0b8c1;
  box-shadow: 0 0 6px 0 rgba(199, 117, 130, 0.31);
}

.title {
  font-size: 18px;
  color: #303032;
  line-height: 20px;
  margin-left: 65px;
  margin-top: 50px;
}

.item {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 30px;
}

.align {
  align-items: center;
}

.item_title {
  width: 150px;
  font-size: 18px;
  color: #303032;
  text-align: right;
  line-height: 20px;
  margin-right: 15px;
}

.item_content {
  font-size: 18px;
  color: #303032;
  line-height: 20px;
}

.card_input {
  width: 296px;
  height: 34px;
  border: 1px solid #88898e;
  border-radius: 10px;
  margin-right: 10px;
  padding-left: 10px;
}

.btn_pay {
  width: 300px;
  height: 50px;
  display: block;
  margin: 50px auto;
}

.flowpath {
  display: flex;
  flex-flow: column;
  font-size: 16px;
  color: #88898e;
  line-height: 34px;
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Recharge.vue